import api, { API_ROOT } from "./axios";
import type { AuthUser, ApiMessage } from "@/types";

/** Must match backend `GET /api/auth/google` (see `AuthController.googleRedirect`). */
export const getGoogleAuthUrl = () => `${API_ROOT}/auth/google`;

export const logout = () =>
  api.post<ApiMessage>("/auth/logout").then((r) => r.data);

export const getMe = () => api.get<AuthUser>("/users/me").then((r) => r.data);

export const deleteAccount = () =>
  api.delete<ApiMessage>("/users/me").then((r) => r.data);
